import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="w-full bg-white shadow-sm py-1">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center px-6">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="/logo.png" // Replace with your logo path
            alt="Logo"
            className="h-20 w-auto object-contain rounded-full"
          />
        </div>

        {/* Hamburger Icon */}
        <div
          className="lg:hidden text-2xl text-pink-600 cursor-pointer"
          onClick={toggleMenu}
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </div>

        {/* Nav Links (Desktop) */}
        <nav className="hidden lg:flex items-center gap-8 text-sm font-semibold">
          <a href="#home" className="text-pink-600 flex items-center gap-1">
            Home
          </a>
          <a href="#our-solutions" className="text-black hover:text-pink-600">
            Our Solutions
          </a>
          <a href="#how-it-works" className="text-black hover:text-pink-600">
            How It Works
          </a>
          <a
            href="#our-work"
            className="text-black hover:text-pink-600 flex items-center gap-1"
          >
            Our Work
          </a>
          <a href="#testimonials" className="text-black hover:text-pink-600">
            Testimonials
          </a>
        </nav>

        {/* Start Now Button (Desktop) */}
        <div className="hidden lg:block">
          <a href="https://www.instagram.com/rankmybook?igsh=b2NmcTJnbnI3Zndw">
            <button className="border border-pink-500 text-pink-600 px-5 py-2 rounded-full font-bold text-sm hover:bg-pink-100 transition">
              Contact Us
            </button>
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden px-6 mt-4">
          <nav className="flex flex-col gap-4 text-sm font-semibold">
            <a href="#home" className="text-pink-600">
              Home
            </a>
            <a href="#our-solutions" className="text-black hover:text-pink-600">
              Our Solutions
            </a>
            <a href="#how-it-works" className="text-black hover:text-pink-600">
              How It Works
            </a>
            <a href="#our-work" className="text-black hover:text-pink-600">
              Our Work
            </a>
            <a href="#testimonials" className="text-black hover:text-pink-600">
              Testimonials
            </a>
            <a href="https://www.instagram.com/rankmybook?igsh=b2NmcTJnbnI3Zndw">
              <button className="mt-4 border border-pink-500 text-pink-600 px-5 py-2 rounded-full font-bold text-sm hover:bg-pink-100 transition">
                Contact Us
              </button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
